<template>
  <div class="search-box">
    <el-input
      v-model="newValue"
      size="small"
      placeholder="请输入名称"
      clearable
      @change="search"
    />
    <el-button
      class="btn"
      size="small"
      @click="search">搜索</el-button>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    value: String,
  },
  data() {
    return {
      newValue: this.value,
    };
  },
  watch: {
    value(vl) { this.newValue = vl; },
    newValue(vl) { this.$emit('update:value', vl); },
  },
  methods: {
    search() {
      this.$emit('onSearch', this.newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box{
  display: flex;
  flex-direction: row;
  align-items: center;

  .btn{
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IMTable/components/search/index.vue